// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://aylskrgqvarcbbnjjaje.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF5bHNrcmdxdmFyY2JibmpqYWplIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDI0Mzc4MTMsImV4cCI6MjA1ODAxMzgxM30.OM_ePaCkp3ElK7CW9h5aPVVpuHth_x0sayQJIPQXsl0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);